import { Stack } from "@mui/material"
import { StandardSwitch } from "lib/@components/binding/bound-components"

export function SimilarityAvailabilityFilter({ showAvailable, showLocked, onShowAvailable, onShowLocked }) {
    return (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
            <StandardSwitch
                value={showAvailable}
                onChange={onShowAvailable}
                label="Show Available"
                data-cy="show-available-toggle"
            />
            <StandardSwitch
                value={showLocked}
                onChange={onShowLocked}
                label="Show Locked"
                data-cy="show-locked-toggle"
            />
        </Stack>
    )
}
